import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TextareaField from "../../ui/form/TextAreaField";
import apiRequest from "../../../utils/admin/apiRequest";
import toast from "react-hot-toast";

const PolicyInfo = () => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const policies = setting?.policies || {};

  const defaultPolicyData = {
    terms_and_conditions: policies?.terms_and_conditions || "",
    privacy_policy: policies?.privacy_policy || "",
    return_policy: policies?.return_policy || "",
    shipping_policy: policies?.shipping_policy || "",
  };

  const [policyData, setPolicyData] = useState(defaultPolicyData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (setting?.policies) {
      setPolicyData((prev) => ({
        ...prev,
        ...setting.policies,
      }));
    }
  }, [setting]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPolicyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiRequest.updateSetting({
        data: { policies: policyData }, // Posting data under `policies` object
      });
      toast.success(response?.data?.message || "Policy info updated.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update policy info.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="space-y-4 bg-white p-4 rounded" onSubmit={handleSubmit}>
      <h2 className="text-lg font-semibold text-gray-700">
        Policy Information
      </h2>

      <TextareaField
        label="Terms and Conditions"
        id="terms_and_conditions"
        name="terms_and_conditions"
        value={policyData.terms_and_conditions}
        onChange={handleChange}
      />
      <TextareaField
        label="Privacy Policy"
        id="privacy_policy"
        name="privacy_policy"
        value={policyData.privacy_policy}
        onChange={handleChange}
      />
      <TextareaField
        label="Return Policy"
        id="return_policy"
        name="return_policy"
        value={policyData.return_policy}
        onChange={handleChange}
      />
      <TextareaField
        label="Shipping Policy"
        id="shipping_policy"
        name="shipping_policy"
        value={policyData.shipping_policy}
        onChange={handleChange}
      />

      <button
        type="submit"
        disabled={loading}
        className="px-4 py-2 text-sm text-white bg-primary rounded hover:bg-primaryDark"
      >
        {loading ? "Saving..." : "Update Policy Info"}
      </button>
    </form>
  );
};

export default PolicyInfo;
